// Copyright (c) 2017 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const ClaimTypes = t.list(KeyValuePair, 'ClaimTypes');

export const getDefaultState = () => new ClaimTypes([]);

export default ClaimTypes;



// WEBPACK FOOTER //
// ./src/shared/state/claim-types.js